import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { SparklesIcon } from 'lucide-react';
export function ProofSection() {
  return <AnimatedSection className="py-16 md:py-24 px-4 sm:px-6" data-id="element-147">
      <div className="max-w-3xl mx-auto" data-id="element-148">
        <div className="glass-card rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-149">
          <div className="absolute -top-10 -left-10 w-32 h-32 bg-[#D4A853] rounded-full opacity-5 blur-3xl" data-id="element-150" />
          <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-[#4ECDC4] rounded-full opacity-5 blur-3xl" data-id="element-151" />

          <SparklesIcon className="w-10 h-10 text-[#D4A853] mx-auto mb-6" data-id="element-152" />

          <p className="font-display text-xl md:text-2xl text-white leading-relaxed italic relative z-10" data-id="element-153">
            "En los primeros 7 días, notarás cómo la tensión en tu mandíbula
            desaparece al acostarte y cómo ese{' '}
            <span className="text-[#4ECDC4]" data-id="element-154">"ruido mental"</span> que te
            impedía dormir se reduce hasta convertirse en un{' '}
            <span className="text-[#D4A853]" data-id="element-155">silencio absoluto</span>."
          </p>
        </div>
      </div>
    </AnimatedSection>;
}